import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { Pathways } from "@/components/Pathways";
import { Manifesto } from "@/components/Manifesto";
import { Founder } from "@/components/Founder";
import { Programs } from "@/components/Programs";
import { ImpactGoals } from "@/components/ImpactGoals";
import { Campus } from "@/components/Campus";
import { Events } from "@/components/Events";
import { Donate } from "@/components/Donate";
import { VolunteerForm } from "@/components/VolunteerForm";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#08080C] min-h-screen" data-testid="home-page">
      <Nav />
      <Hero />
      <MarqueeStrip />
      <Pathways />
      <Manifesto />
      <Founder />
      <Programs />
      <ImpactGoals />
      <Campus />
      <Events />
      <Donate />
      <VolunteerForm />
      <ContactForm />
      <Footer />
    </div>
  );
}
